import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { ROLES } from 'globalconfig/constants/keys';
import { hasRestrictedRole, hasEnabledFeature } from 'globalutils/fmUtils';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({}) => {
  return {
    autoPayment: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      default: () => false,
    },
    leftform_fields_initialTrucks: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.UNDER_WRITER, ROLES.LOSS_CONTROL, ROLES.CLAIM_ADJUSTER]),
      default: () => false,
    },
    leftform_fields_speedLimit: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasEnabledFeature('cameraIntegrationEnabled'),
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
